module.exports = __webpack_public_path__ + "img/icons B_2.e83922bb.png";